<template>
  <div class="todo-create-coupon">
    <el-row type="flex">
      <el-col>
        <el-collapse @change="defaultCollpase" v-model="defaultCollpaseVal" accordion>
          <el-collapse-item title="Create Services Discount" name="discount">
          <el-divider />
            <!--form-->
            <template>
              <el-form :model="serviceForm" ref="serviceForm" v-loading="loading">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="Select Service Provider" :rules="[{required: true}]">
                      <el-select v-model="serviceForm.serviceProvider" @change="onServiceProviderChange($event)" placeholder="Select Service provider" filterable>
                        <el-option
                          v-for="item in getServicePList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">{{item.name}} ({{item.email}})
                        </el-option>
                      </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Select Service" :rules="[{required: true}]">
                      <el-select v-model="serviceForm.service" placeholder="Select Service" filterable>
                          <el-option
                            v-for="item in getServicesList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                          </el-option>
                      </el-select>
                      </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="Discount %" :rules="[{required: true}]">
                    <el-input placeholder="Enter Discount %" v-model="serviceForm.discount" @change="checkDiscountisValid($event)"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="Start Date" :rules="[{required: true}]">
                    <el-date-picker type="date" v-model="serviceForm.startDate" placeholder="Start Date" value-format="yyyy-MM-dd 00:00:00" ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="Expiry Date" :rules="[{required: true}]">
                    <el-date-picker type="date" v-model="serviceForm.expiryDate" placeholder="Expiry Date" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <el-form-item class="form-buttons">
                      <el-button type="primary" @click="onSubmit(serviceForm)">Create</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item class="form-buttons">
                      <el-button @click="onClear(serviceForm)">Cancel</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-collapse-item>
          <el-collapse-item title="Create Coupons" name="coupon">
          <el-divider />
            <el-row>
              <el-col :span="12">
                <el-select v-model="userTypeVal" :placeholder="loadingUserTypeLabel" @change="changeUserType($event)">
                  <el-option
                  v-for="item in userTypeOptions"
                  :key="item.id"
                  :label="item.typeDescription"
                  :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="12" v-if="userTypeVal !== 1 && userTypeVal">
                <div align="right">
                  <el-button size="mini" type="primary" @click="addUserCondition()">Add</el-button>
                </div>
              </el-col>
            </el-row>
            <template v-if="userTypeVal">

              <!-- <template><h3>In progress</h3></template> -->
              <el-form :model="couponForm" ref="couponForm" v-loading="loading">
                <template v-if="userTypeVal !== 1">
                  <template v-for="(couponCondition,index) in couponConditions">
                    <el-row v-bind:key="index">
                        <el-col :span="6">
                          <!-- <el-input placeholder="Select Condition" v-model="slot.count" v-bind:key="slot.count"></el-input> -->
                          <el-form-item label="Select Condition" :rules="[{required: true}]">
                            <el-select v-model="couponCondition.condition" placeholder="Select Condition">
                              <el-option v-for="item in userTypeConditions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item :label=userTypeLabel>
                            <el-input type="number" placeholder="" v-model="couponCondition.value" name="couponConditions[][value]" @change="checkcouponConditionisValid(couponCondition.value,index)"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <template v-if="index > 0">
                          <el-button type="danger" size="mini" @click="removeUserCondition(index)">Delete</el-button>
                          </template>
                        </el-col>
                    </el-row>
                  </template>
                </template>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="Discount Type" :rules="[{required: true}]">
                      <el-select v-model="couponForm.discountType" @change="onDiscountTypeChange($event)">
                        <el-option
                          v-for="item in discountOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label=discountLabel.v2 :rules="[{required: true}]">
                    <el-input :placeholder=discountLabel.v1 v-model="couponForm.discount" @change="checkDiscountisValid($event)"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Expiry Date" :rules="[{required: true}]">
                    <el-date-picker type="date" v-model="couponForm.expiryDate" placeholder="Expiry Date" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="Notification Message" :rules="[{required: true}]">
                    <el-input type="textarea" :autosize="{minRows: 4, maxRows: 4}" placeholder="Enter Notification Message" v-model="couponForm.notificationMessage"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="Coupon Description" :rules="[{required: true}]">
                    <el-input type="textarea" :autosize="{minRows: 4, maxRows: 4}" placeholder="Enter Notification Message" v-model="couponForm.description"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-col :span="4">
                  <template>
                  <el-button type="primary" size="mini" @click="generateCoupon()">Generate Coupon</el-button>
                  </template>
                </el-col>
              </el-form>
            </template>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getServiceProviders, getServices, saveServiceDiscount, saveCoupons, getUserTypes } from '@/api/vouchers'
  import moment from 'moment'
  import Vue from 'vue'
  export default {
    name: 'create-coupon',
    props: {
    },
    data() {
      return {
        moment: moment,
        getServicePList: [],
        getServicesList: [],
        defaultCollpaseVal: '',
        userTypeVal: '',
        serviceForm: {
          serviceProvider: '',
          service: '',
          discount: '',
          expiryDate: '',
          startDate: ''
        },
        /* userTypeOptions: [{
          value: 'new_user',
          label: 'New User'
        }, {
          value: 'no_of_services_booked',
          label: 'No of services Booked'
        }, {
          value: 'days_passed_since_last_booking',
          label: 'Days passed since the last booking'
        }, {
          value: 'time_user_existed',
          label: 'The time that the user has existed'
        }],  */
        userTypeOptions: [],
        loading: true,
        // coupons
        couponCondition: {
          condition: '',
          value: 0
        },
        couponConditions: [{ condition: '', value: '' }],
        userTypeConditions: [{
          value: 'equalTo',
          label: 'Equal To'
        }, {
          value: 'greaterThan',
          label: 'Greater than'
        }, {
          value: 'lessThan',
          label: 'Less Than'
        }, {
          value: 'greaterThanEqualTo',
          label: 'Greater Than Equal To'
        }, {
          value: 'lessThanEqualTo',
          label: 'Less Than Equal To'
        }],
        couponForm: {
          ccondition: this.couponConditions,
          discount: '',
          expiryDate: '',
          notificationMessage: '',
          couponCondition: '',
          discountType: 'percent'
        },
        userTypeLabel: '',
        loadingUserTypeLabel: '',
        discountOptions: [{
          value: 'percent',
          label: 'Percent'
        }, {
          value: 'value',
          label: 'Value'
        }],
        discountLabel: {
          v1: '',
          v2: ''
        }
      }
    },
    methods: {
      async getServiceProvidersList() {
        try {
          const { data } = await getServiceProviders()
          this.getServicePList = data
          this.getServicePList.sort(function(a, b) {
              const aa = (a.name === null || a.name === undefined) ? '' : a.name.toLowerCase()
              const bb = (b.name === null || a.name === undefined) ? '' : b.name.toLowerCase()
              return aa > bb ? 1 : bb > aa ? -1 : 0
          })
        } catch (err) {
        }
        this.loading = false
      },
      onServiceProviderChange(event) {
        if (event) {
          this.getServicesListFunc(event)
        }
      },
      async getServicesListFunc(providerId) {
        this.loading = true
        this.getServicesList = []
        this.serviceForm.service = ''
        try {
        const { data } = await getServices(providerId)
          this.getServicesList = data
          this.getServicesList.sort(function(a, b) {
              const aa = (a.title === null || a.title === undefined) ? '' : a.title.toLowerCase()
              const bb = (b.title === null || a.title === undefined) ? '' : b.title.toLowerCase()
              return aa > bb ? 1 : bb > aa ? -1 : 0
          })
        } catch (err) {
        }
        this.loading = false
      },
      onSubmit() {
        this.loading = true
        const formData = {
          type: 'discount',
          serviceId: this.serviceForm.service,
          discount: this.serviceForm.discount,
          expiryDate: this.serviceForm.expiryDate,
          startDate: this.serviceForm.startDate
        }
        this.saveDiscount(formData)
        this.loading = false
      },
      async saveDiscount(formData) {
        this.loading = true
        try {
          const { data } = await saveServiceDiscount(formData)
          this.getServicesList = data
          this.resetForm()
        } catch (err) {
        }
        this.loading = false
      },
      defaultCollpase() {
        if (this.defaultCollpaseVal === 'discount') {
          this.loading = true
          this.getServiceProvidersList()
          this.resetForm()
        }
        if (this.defaultCollpaseVal === 'coupon') {
          this.loading = true
          this.getUserTypesFunc()
          this.onDiscountTypeChange('percent')
          this.loading = false
        }
      },
      onClear() {
        this.resetForm()
      },
      resetForm() {
        this.serviceForm.service = ''
        this.serviceForm.discount = ''
        this.serviceForm.expiryDate = ''
        this.serviceForm.startDate = ''
      },
      checkDiscountisValid(event) {
        if (!(event >= 1 && event <= 100)) {
          alert('Invalid Input')
          this.serviceForm.discount = ''
          this.couponForm.discount = ''
        }
      },
      // coupon
      async getUserTypesFunc() {
        this.loading = true
        this.loadingUserTypeLabel = 'Loading...'
        try {
          const { data } = await getUserTypes()
          this.userTypeOptions = data
        } catch (err) {
        }
        this.loading = false
        this.loadingUserTypeLabel = 'Select User Type'
      },
      addUserCondition: function() {
        this.couponConditions.push(Vue.util.extend({}, this.couponCondition))
      },
      removeUserCondition: function(index) {
        Vue.delete(this.couponConditions, index)
      },
      generateCoupon() {
        const formData = {
          userType: this.userTypeVal,
          description: this.couponForm.description,
          couponCondition: this.couponConditions,
          discount: this.couponForm.discount,
          expiryDate: this.couponForm.expiryDate,
          notificationMessage: this.couponForm.notificationMessage,
          discountType: this.couponForm.discountType
        }
        this.saveCoupon(formData)
      },
      async saveCoupon(formData) {
        this.loading = true
        try {
          const { data } = await saveCoupons(formData)
          this.resetForm()
          setTimeout(() => this.$emit('newCoupon', { userTypeVal: this.userTypeVal, couponId: data.coupon_id }), 1000)
        } catch (err) {
        }
        this.loading = false
      },
      changeUserType(event) {
        const lavelVal = this.userTypeOptions.find(o => o.id === event)
        this.userTypeLabel = lavelVal.typeDescription
        this.couponConditions = [{ condition: '', value: '' }]
      },
      onDiscountTypeChange(event) {
        if (event === 'percent') {
          this.discountLabel.v1 = 'Enter Discount %'
          this.discountLabel.v2 = 'Discount %'
        } else {
          this.discountLabel.v1 = 'Discount Value(in $) '
          this.discountLabel.v2 = 'Discount(in $)'
        }
      },
      checkcouponConditionisValid(event, index) {
        if (event <= 0) {
          alert('Invalid Input')
          this.couponConditions[index].value = ''
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .form-buttons{
    margin-right: 5px;
  }

  .el-collapse-item .is-active {
    background-color: #e9e6e3;
  }
  .el-form{
    margin-top: 20px;
  }
  .el-collapse-item .el-collapse-item__header{
    padding-left: 5px;
  }
</style>
